import { render, staticRenderFns } from "./SimCardBlock.vue?vue&type=template&id=883fa50a&scoped=true&"
import script from "./SimCardBlock.vue?vue&type=script&lang=js&"
export * from "./SimCardBlock.vue?vue&type=script&lang=js&"
import style0 from "./SimCardBlock.vue?vue&type=style&index=0&id=883fa50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883fa50a",
  null
  
)

export default component.exports